import React from "react"
import { AppText, AppTextVariant } from "~/ui/app-text"
import circleWavyCheck from "~/images/circle-wavy-check"
import { BadgeSize } from "~/ui/user-avatar"

interface MessageHeaderProps {
  displayName: string
  badgeSize?: number
  showVerified?: boolean
  textVariant?: AppTextVariant
}

export const MessageHeader: React.FC<MessageHeaderProps> = ({
  displayName,
  badgeSize = BadgeSize.sm,
  showVerified = false,
  textVariant = "hairline-2",
}) => {
  return (
    <div className="inline-flex flex-row items-center gap-1">
      <AppText variant={textVariant} className="line-clamp-1 text-base-black">
        {displayName}
      </AppText>
      {showVerified && <circleWavyCheck.Icon width={badgeSize} height={badgeSize} />}
    </div>
  )
}

export default MessageHeader
